import * as React from "react";
const SvgFiRrAgeRestrictionTwelve = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-age-restriction-twelve_svg__a)">
      <path
        fill="#062147"
        d="M24 12a1 1 0 0 1-1 1h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 0 1 1 1m-7-2c0-1.654-1.346-3-3-3s-3 1.346-3 3a1 1 0 1 0 2 0 1 1 0 1 1 2 0c0 1.193-.949 2.013-1.955 2.88C12.04 13.746 11 14.643 11 16a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-2.329c.209-.199.446-.404.68-.606C15.532 13.376 17 12.11 17 10m-9 7a1 1 0 0 0 1-1V8.307c0-.542-.326-1.019-.831-1.216a1.3 1.3 0 0 0-1.439.334L4.998 9.326a1 1 0 0 0 1.479 1.348L7 10.1V16a1 1 0 0 0 1 1m13.767.162a1 1 0 0 0-1.384.292A9.97 9.97 0 0 1 12 22C6.486 22 2 17.514 2 12S6.486 2 12 2a9.98 9.98 0 0 1 8.383 4.546 1 1 0 0 0 1.676-1.092A11.97 11.97 0 0 0 12 0C5.383 0 0 5.383 0 12s5.383 12 12 12c4.071 0 7.832-2.039 10.059-5.454a1 1 0 0 0-.292-1.384"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-age-restriction-twelve_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAgeRestrictionTwelve;
